import { Component, ElementRef, OnInit, Output } from '@angular/core';
import { AlarmeService } from '../../_services/http/alarme.service';
import { BehaviorSubject, zip } from 'rxjs';
import { EsService } from '../../_services/http/es.service';
import { SpService } from '../../_services/http/sp.service';
import { PgmService } from '../../_services/http/pgm.service';
import { EtapeService } from '../../_services/http/etape.service';
import { SousSystemeService } from '../../_services/http/sous-systeme.service';
import { EquipmentService } from '../../_services/http/equipment.service';
import { AsService } from '../../_services/http/as.service';
import { RapportSousSystemeService } from '../../_services/http/rapport-sous-systeme.service';
import { KafkaHealthService } from '../../_services/http/kafka-health.service';
import { LogService } from '../../_services/http/log.service';
import { AvancementService } from '../../_services/http/avancement.service';
import { SessionEditionService } from '../../_services/http/session-edition.service';

interface AdminConsoleRowInterface {
  title: string;
  status: BehaviorSubject<string>;
  error: BehaviorSubject<string | undefined>;
  refresh: () => void;
}

@Component({
  selector: 'app-admin-console',
  templateUrl: './admin-console.component.html',
  styleUrls: ['./admin-console.component.scss'],
})
export class AdminConsoleComponent implements OnInit {
  indicators: AdminConsoleRowInterface[] = [
    {
      title: 'Kafka',
      error: this.kafkaService.connectionWithError$,
      status: this.kafkaService.active$,
      refresh: () => this.kafkaService.refreshHubConnection(),
    },
    {
      title: 'Alarmes',
      error: this.alarmeService.connectionWithError$,
      status: this.alarmeService.state$,
      refresh: () => this.alarmeService.refreshHubConnection(),
    },
    {
      title: 'Evènements spontanés',
      error: this.esService.connectionWithError$,
      status: this.esService.state$,
      refresh: () => this.esService.refreshHubConnection(),
    },
    {
      title: 'Scénarios préprogrammés',
      error: this.spService.connectionWithError$,
      status: this.spService.state$,
      refresh: () => this.spService.refreshHubConnection(),
    },
    {
      title: 'Etapes scénario',
      error: this.etapeService.connectionWithError$,
      status: this.etapeService.state$,
      refresh: () => this.etapeService.refreshHubConnection(),
    },
    {
      title: 'Plan gestion mobilité',
      error: this.pgmService.connectionWithError$,
      status: this.pgmService.state$,
      refresh: () => this.pgmService.refreshHubConnection(),
    },
    {
      title: 'Equipements',
      error: this.equipementService.connectionWithError$,
      status: this.equipementService.state$,
      refresh: () => this.equipementService.refreshHubConnection(),
    },
    {
      title: 'Rapports des sous-systèmes',
      error: this.rapportSsService.connectionWithError$,
      status: this.rapportSsService.state$,
      refresh: () => this.rapportSsService.refreshHubConnection(),
    },
    {
      title: 'Logs',
      error: this.logService.connectionWithError$,
      status: this.logService.state$,
      refresh: () => this.logService.refreshHubConnection(),
    },
    {
      title: 'Avancements',
      error: this.avancementService.connectionWithError$,
      status: this.avancementService.state$,
      refresh: () => this.avancementService.refreshHubConnection(),
    },
    {
      title: 'Sous-systèmes',
      error: this.sousSystemeService.connectionWithError$,
      status: this.sousSystemeService.state$,
      refresh: () => this.sousSystemeService.refreshHubConnection(),
    },
    {
      title: "Session d'édition",
      error: this.sessionService.connectionWithError$,
      status: this.sessionService.state$,
      refresh: () => this.sessionService.refreshHubConnection(),
    },
  ];

  constructor(
    private alarmeService: AlarmeService,
    private esService: EsService,
    private spService: SpService,
    private etapeService: EtapeService,
    private pgmService: PgmService,
    private equipementService: EquipmentService,
    private asService: AsService,
    private rapportSsService: RapportSousSystemeService,
    private kafkaService: KafkaHealthService,
    private logService: LogService,
    private avancementService: AvancementService,
    private sousSystemeService: SousSystemeService,
    private sessionService: SessionEditionService,
    private elRef: ElementRef
  ) {}

  ngOnInit(): void {}
}
